<div class="sectionContainer paddedContent">
  <div class="flex-container">
    <div style="flex: 1">
      <h2>Edit Contact</h2>

      <app-contact-form
        [readonly]="false"
        [formMode]="FormMode.Edit"
        [contact]="contact"
        (onsave)="saveContact($event)"
        (oncancel)="cancel()"
        (ondelete)="deleteContact($event)"
      ></app-contact-form>
    </div>
  </div>
</div>
